import React from 'react'
import _ from 'lodash'
import moment from 'moment'
import { ROUTES } from '../../navigation/route-constants'
import CONSTANTS from '../movielist-constants'
import LOCALE from '../MovieListLocale'
import { isInsideShowPeriod } from '../shared'
import MovieInfo from '../../movie/MovieInfo'
import Showtime from '../../showtime/Showtime'
import Poster from '../../movie/Poster'
import ShowtimeTypeList from '../../showtime/ShowtimeTypeList'

export default class ProgramListItem extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showMovieInfo: false,
            screenWidth: document.querySelector('.programv2')?.clientWidth
        }
        this.movieClicked = this.movieClicked.bind(this);
       
        
        this.handleWindowResize = this.handleWindowResize.bind(this);
    }

    componentDidMount() {
        window.addEventListener('resize', this.handleWindowResize);     
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.showMovieInfo != this.state.showMovieInfo) {
            const { appHeightChanged } = this.props;
            setTimeout(() => { appHeightChanged() }, 500); //Workaround for the duration it takes the DOM to rerender with the expanded element so we get the right height...
        }
    }

    componentWillUnmount() {    
        window.removeEventListener('resize', this.handleWindowResize);
    }

    handleWindowResize = _.debounce(() => {
        
        this.setState({ screenWidth: this.screenWidth() });
    })

    screenWidth() {
        const schedule = document.querySelector('.programv2');
       
        return schedule.clientWidth;
    }

    movieClicked(e) {
        const { showMovieInfo } = this.state;
        const { columns, movieClicked } = this.props;
        const dataset = e.target.dataset;
        e.preventDefault();

        if (columns == CONSTANTS.columns.one && dataset.toggleMovieInfo) {
            if (showMovieInfo == false) this.setState({ showMovieInfo: true });
            else this.setState({ showMovieInfo: false });
        } else {
            const movieId = e.currentTarget.id || dataset.movieId;
            if (e.target.tagName == 'IMG' || e.target.tagName == 'H1' || e.target.tagName == 'INPUT' || _.includes(e.target.classList, 'poster-banner'))
                movieClicked(movieId);
        }
    }

    showtimeTypes = [];
    generateShowtimesOnDate() {
        const { movie, showLocationOnShowtime, showtimeClicked, columns, showAsBase, showExpired, showBackInTime } = this.props;
        this.showtimeTypes = []; //reset it so types don't bleed into dates where they don't apply.
       
        return <div className="showtimes" style={{
            display: showLocationOnShowtime ? '' : 'flex', justifyContent: showLocationOnShowtime ? '' : 'space-between',
            flexWrap: showLocationOnShowtime ? '' : 'wrap', gap: showLocationOnShowtime ? '' : '2px'
        }}>
            {_.map(movie.validShowtimes, (showtime) => {
               // console.log(showtime)
                if (showtime.type && !_.find(this.showtimeTypes, showtime.type)) this.showtimeTypes.push(showtime.type);

                const dateTime = moment(showtime.dateTime);
                let text = columns != CONSTANTS.columns.one && showLocationOnShowtime ? `${dateTime.format('LT')} ${showtime.locationName}` : dateTime.format('LT')
                text = columns == CONSTANTS.columns.five && showLocationOnShowtime ? <div>{dateTime.format('LT')}
                    <span style={{ paddingLeft: '20px' }}>{showtime.locationName}</span></div> : dateTime.format('LT')
                let textNoLocation = columns == CONSTANTS.columns.five && showLocationOnShowtime ? <div>{dateTime.format('LT')}
                </div> : dateTime.format('LT')
                
                return <div key={showtime.id} className="row" style={{ width: showLocationOnShowtime ? '' : this.state.screenWidth < 431 ? '100%' : '48%' }}>
                         <div className="showtime-row">
                          {columns == CONSTANTS.columns.one && showLocationOnShowtime ? <div className="location">{showtime.locationName}:</div> : ''}
                        <Showtime key={showtime.id}
                            showtime={showtime}
                            text={text}
                            textNoLocation={textNoLocation}
                            withLocation={columns != CONSTANTS.columns.one && showLocationOnShowtime}
                            showtimeClicked={showtimeClicked}
                            showExpired={showExpired}
                            showBackInTime={showBackInTime}
                           
                        />
                        {isInsideShowPeriod && columns == CONSTANTS.columns.one ? <div className="type">
                            <div>{showtime.type ? showtime.type.name : ''} {showAsBase ? showtime.movieBaseShowName : null}</div>
                        </div> : null}
                    </div>
                    {columns == CONSTANTS.columns.one ? <div className="info">{showtime.info}</div> : null}
                </div>
            })}
        </div>
    }

    render() {
        const { showMovieInfo } = this.state;
        const { movie, rowClasses, appLocale, showAsBase, columns, organizerIds, filterIds, showLocationOnShowtime } = this.props;
       // console.log(movie, 'movie')
        const poster = movie.posters ?
            <a className="poster-container" href={`${window.location.origin}${ROUTES.MOVIE}/${movie.id}?org=${organizerIds}`}>
                <Poster movie={movie} /></a> : null;

        const movieNameLocale = movie.names ? (movie.names[appLocale] ? movie.names[appLocale] : movie.names['da']) : movie.name;

        return (
            <>
            <div className={rowClasses} id={movie.id} onClick={this.movieClicked} >
                {poster}
                <div className="movie-info">
                    <a href={`${window.location.origin}${ROUTES.MOVIE}/${movie.id}?org=${organizerIds}`}>
                       
                            {(window.location.pathname === '/programv2' && columns !== CONSTANTS.columns.one ) || window.location.pathname === '/program-og-fremtidige-filmv2' ? 
                            <div style={{ fontFamily: 'PP Neue Montreal',marginBottom:'20px' }}>
                                <h1 style={{ height:'auto' }}>{movie.name.split('-')[1] && movie.baseId > 0 ? movie.name.split('-')[0] : movie.name} </h1>
                                <p className='otherVersion' >{movie.baseId > 0 && movie.name.split('-')[1] ? movie.name.split('-').pop() : ''}</p>
                            </div>
                  
                            : <h1 style={{height:'auto'} }>{showAsBase ? movie.name : movieNameLocale}</h1>
                          }
                        </a>
                    <div className="flex-container">{this.generateShowtimesOnDate()}</div>
                    {columns === CONSTANTS.columns.one && this.showtimeTypes.length == 0 ? <div style={{height:'35px'} }></div> : ''}
                    {(!filterIds || filterIds.length > 1) && this.showtimeTypes.length > 0 ? <ShowtimeTypeList types={this.showtimeTypes} withLocation={showLocationOnShowtime ? true : false } includeName={true} /> : null}

                    {columns === CONSTANTS.columns.one ? <div className="read-more">
                        <input type="button" className="more-showtimes" data-toggle-movie-info={true} value={LOCALE[appLocale].movieInfo} />
                        <input type="button" className="more-showtimes" data-movie-id={movie.id} value={LOCALE[appLocale].allShowtimes} />

                        {columns === CONSTANTS.columns.one ? <MovieInfo addClass={showMovieInfo ? 'slide-down' : 'slide-up'} movie={movie} showTitle={false} appLocale={appLocale} /> : null}
                    </div> : null}
                </div>
                </div>
                {columns === CONSTANTS.columns.one ? <hr style={{width:'100%',opacity:'0.1',margin:'0px 0px 40px'} }></hr> : ''}
            </>
        )
    }
}